"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Constant = require("../../Constant");

var _Button = require("../../Button");

var _Typography = require("../../Typography");

var _hooks = require("../../hooks");

var _theme, _theme2, _theme3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject11() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  /* Remove default styles so the bar and value can be styled */\n  -webkit-appearance: none;\n  appearance: none;\n\n  /* Firefox */\n  background-color: ", ";\n  border-radius: 4px;\n\n  /* All browsers */\n  height: 0.7rem;\n  margin-top: 8px;\n  width: 100%;\n\n  /* The progress bar container. Visually, it appears as the uncompleted portion of the progress bar. */\n  &::-webkit-progress-bar {\n    background-color: ", ";\n    border-radius: 5px;\n  }\n\n  /* The completed portion of the progress bar */\n  &::-webkit-progress-value {\n    background-color: ", ";\n    border-radius: 5px;\n  }\n\n  /* The completed portion of the progress bar */\n  &::-moz-progress-bar {\n    background-color: ", ";\n  }\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n          /* Safari */\n          min-width: 45%;\n          overflow-wrap: break-word;\n          /* Chrome */\n          overflow-wrap: anywhere;\n        "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  /* The ideal width is 412px. But this can shrink as the viewport gets smaller */\n  flex-basis: 412px;\n  /* Maintains space between the wrapper and the Remove icon at small viewport sizes */\n  margin-right: 24px;\n\n  /* Prevents long file names with no spaces from breaking out of the flex container on small screens */\n  @media print, screen and (max-width: ", "px) {\n    ", "\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  margin-right: 12px;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  /* The SVG should not get smaller as the viewport size changes */\n  flex-shrink: 0;\n  margin-right: 24px;\n\n  path:first-of-type {\n    fill: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  color: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  height: 2.4rem;\n  padding: 4px;\n  width: 2.4rem;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  align-items: center;\n  border: 1px solid ", ";\n  bottom: 0;\n\n  display: flex;\n  /* The absolute positioning on the input takes it out of the flex flow so the label needs to use all available space. */\n  flex-grow: 1;\n  /* Prevent the content from popping outside the container on iOS */\n  min-width: 45%;\n  padding: 15px 24px;\n\n  > :last-child:not(", ") {\n    /* The Remove and UploadIcon svg should not shrink as the viewport gets smaller */\n    flex-shrink: 0;\n    /* Both the Remove and UploadIcon are against the right edge */\n    margin-left: auto;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  /* The input is hidden and positioned this way to support assistive technology on mobile devices */\n  opacity: 0;\n  position: absolute;\n\n  &[data-focus-visible-added]:focus + label {\n    border-color: ", ";\n    outline: 2px solid ", ";\n  }\n\n  &:hover {\n    cursor: pointer;\n  }\n\n  &:hover + label {\n    border-color: ", ";\n    cursor: pointer;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  min-height: 7.2rem;\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var themedStateColors = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEPOINT, _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, _Constant.Themes.CALIBER, _Constant.Color.CALIBER_BLUE_NEW), (0, _defineProperty2.default)(_theme, _Constant.Themes.FIGURE, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, _Constant.Themes.PETERSENDEAN, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, _Constant.Themes.PELLA, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var iconColors = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _Constant.Color.DARK_GREY_2), (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEPOINT, _Constant.Color.HOMEPOINT_NAVY), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _Constant.Color.DARK_GREY_2), (0, _defineProperty2.default)(_theme2, _Constant.Themes.CALIBER, _Constant.Color.DARK_GREY_2), (0, _defineProperty2.default)(_theme2, _Constant.Themes.FIGURE, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme2, _Constant.Themes.PETERSENDEAN, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme2, _Constant.Themes.PELLA, _Constant.Color.FOCUS_B), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme2));

var Wrapper = _styledComponents.default.div.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className || ''
  };
})(_templateObject());

var Input = _styledComponents.default.input.attrs(function (_ref2) {
  var className = _ref2.className,
      fsMask = _ref2.fsMask;
  return {
    className: "".concat(fsMask ? 'fs-mask ' : '').concat(className || '')
  };
})(_templateObject2(), themedStateColors, themedStateColors, themedStateColors);

var LabelText = (0, _styledComponents.default)(_Typography.Typography.BodyBoldGrey)(_templateObject3());

var InputLabel = _styledComponents.default.label(_templateObject4(), _Constant.Color.DARK_GREY_2, LabelText);

var Remove = (0, _styledComponents.default)(_Button.DismissButton)(_templateObject5());
var ErrorText = (0, _styledComponents.default)(_Typography.Typography.BodyBold)(_templateObject6(), _Constant.Color.ERROR);

var UploadIcon = function UploadIcon() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "18",
    height: "24",
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 14L1 18C1 18.5523 1.44772 19 2 19L16 19C16.5523 19 17 18.5523 17 18L17 14",
    stroke: _Constant.Color.DARK_GREY_2,
    strokeWidth: "1.5",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M9 14.5L9 5M9 5L12 8M9 5L6 8",
    stroke: _Constant.Color.DARK_GREY_2,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var DocumentIconBase = _styledComponents.default.svg(_templateObject7(), iconColors);

var DocumentIcon = function DocumentIcon() {
  return /*#__PURE__*/_react.default.createElement(DocumentIconBase, {
    width: "17",
    height: "24",
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 0H11.5L17 5.5V24H0V0Z",
    className: "document-icon-base"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11 0V6H17",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 10H15",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 6H8",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 14H11",
    stroke: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 18H15",
    stroke: "white"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "17",
    height: "24",
    fill: "white"
  }))));
};

var ErrorIconBase = _styledComponents.default.svg(_templateObject8());

var ErrorIcon = function ErrorIcon() {
  return /*#__PURE__*/_react.default.createElement(ErrorIconBase, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 22L12 2L23 22H1Z",
    fill: "#E01B25",
    stroke: "#E01B25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.75 9C12.75 8.58579 12.4142 8.25 12 8.25C11.5858 8.25 11.25 8.58579 11.25 9H12.75ZM11.25 16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16H11.25ZM11.25 9V16H12.75V9H11.25Z",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "19",
    r: "1",
    fill: "white"
  }));
};
/* `span` is used because `div` is not valid inside of a `label` */


var InnerWrapper = _styledComponents.default.span(_templateObject9(), _Constant.Width.XS, function (props) {
  return !props.$space && (0, _styledComponents.css)(_templateObject10());
});

var barColor = (0, _styledTheming.default)('mode', (_theme3 = {}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEPOINT, _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme3, _Constant.Themes.CALIBER, _Constant.Color.SEA), (0, _defineProperty2.default)(_theme3, _Constant.Themes.FIGURE, _Constant.Color.SEA), (0, _defineProperty2.default)(_theme3, _Constant.Themes.PETERSENDEAN, _Constant.Color.SEA), (0, _defineProperty2.default)(_theme3, _Constant.Themes.PELLA, _Constant.Color.SEA), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_BLUEPRINT), _theme3));

var Progress = _styledComponents.default.progress(_templateObject11(), _Constant.Color.GREY_3, _Constant.Color.GREY_3, barColor, barColor);

var FileInput = function FileInput(_ref3) {
  var id = _ref3.id,
      label = _ref3.label,
      name = _ref3.name,
      value = _ref3.value,
      accept = _ref3.accept,
      disabled = _ref3.disabled,
      required = _ref3.required,
      errorText = _ref3.errorText,
      onChange = _ref3.onChange,
      _ref3$file = _ref3.file,
      file = _ref3$file === void 0 ? {} : _ref3$file,
      onRemove = _ref3.onRemove,
      className = _ref3.className,
      fsMask = _ref3.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref3, ["id", "label", "name", "value", "accept", "disabled", "required", "errorText", "onChange", "file", "onRemove", "className", "fsMask"]);
  var fileInputRef = (0, _react.useRef)(null);
  var removeButtonRef = (0, _react.useRef)(null);
  var _file$progress = file.progress,
      progress = _file$progress === void 0 ? 0 : _file$progress,
      _file$complete = file.complete,
      complete = _file$complete === void 0 ? false : _file$complete;
  var previousProgress = (0, _hooks.usePrevious)(progress);

  var _useState = (0, _react.useState)(progress),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      currentProgress = _useState2[0],
      setCurrentProgress = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      hasSpace = _useState4[0],
      setHasSpace = _useState4[1];

  (0, _react.useEffect)(function () {
    if (progress !== currentProgress) {
      setCurrentProgress(progress);
    }
  }, [currentProgress, progress]);
  (0, _react.useEffect)(function () {
    // Place focus on the Remove button when it appears
    if (!previousProgress && progress > 0) {
      removeButtonRef.current.focus();
    } // Only manage focus for the file input if the upload process began


    if (previousProgress > 0 && progress <= 0) {
      fileInputRef.current.focus();
    }
  }, [progress, previousProgress]); // Long file names with no spaces overflow on small screens. `hasSpace` is used to conditionally apply CSS

  (0, _react.useLayoutEffect)(function () {
    // Check if the filename has a whitespace character
    if (/\s/g.test(label)) {
      setHasSpace(true);
    } else {
      setHasSpace(false);
    }
  }, [label]);

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: 'file',
    id: id,
    name: name,
    accept: accept,
    disabled: disabled,
    required: required,
    onChange: onChange,
    'aria-invalid': errorText ? 'true' : null,
    ref: fileInputRef,
    fsMask: fsMask
  });

  return /*#__PURE__*/_react.default.createElement(Wrapper, {
    className: className
  }, !progress && /*#__PURE__*/_react.default.createElement(Input, inputProps), /*#__PURE__*/_react.default.createElement(InputLabel, {
    htmlFor: progress > 0 ? null : id,
    as: progress > 0 ? 'div' : null
  }, errorText === '' ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, currentProgress > 0 ? /*#__PURE__*/_react.default.createElement(DocumentIcon, null) : null, /*#__PURE__*/_react.default.createElement(InnerWrapper, {
    as: "span",
    $space: hasSpace
  }, /*#__PURE__*/_react.default.createElement(LabelText, {
    as: "span"
  }, label), currentProgress > 0 && !complete ? /*#__PURE__*/_react.default.createElement(Progress, {
    value: currentProgress,
    max: "100"
  }) : null)) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(ErrorIcon, null), /*#__PURE__*/_react.default.createElement(ErrorText, {
    as: "span"
  }, errorText)), progress > 0 ? /*#__PURE__*/_react.default.createElement(Remove, {
    onClick: onRemove,
    text: "Remove upload",
    forwardRef: removeButtonRef
  }) : /*#__PURE__*/_react.default.createElement(UploadIcon, null)));
};

FileInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** The label for the input */
  label: _propTypes.default.string.isRequired,

  /** Name of the input */
  name: _propTypes.default.string.isRequired,

  /** File types that are accepted */
  accept: _propTypes.default.string,

  /** Value that controls the input */
  value: _propTypes.default.string,

  /** Whether or not the input is disabled */
  disabled: _propTypes.default.bool,

  /** Used for validation */
  errorText: _propTypes.default.string,

  /** Whether or not the input is required */
  required: _propTypes.default.bool,

  /** object describing the state of the upload
   *
   * percent - determines if the spinner should be shown
   *
   * complete - determines if the checkmark should be shown
   */
  file: _propTypes.default.shape({
    progress: _propTypes.default.number,
    complete: _propTypes.default.bool
  }),

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** Function that runs when a file is removed */
  onRemove: _propTypes.default.func.isRequired,

  /** class name string */
  className: _propTypes.default.string,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
FileInput.defaultProps = {
  value: '',
  accept: 'image/png, image/jpeg',
  disabled: false,
  errorText: '',
  file: undefined,
  required: false,
  className: '',
  fsMask: true
};
var _default = FileInput;
exports.default = _default;